module.exports = __webpack_public_path__ + "static/img/px1.af7715b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/px1.png
// module id = /OBV
// module chunks = 2